import { hasKnightmedsCabinetId } from "./runtime-config";

export const EMR_BUILD_VERSION = '5-7-2026-14:46';

export interface CustomerInfo {
  id: string;
  www: string;
  logo: string;
  emailDomains: string[];
}

const customerCalvin: CustomerInfo = {
  id: 'Calvin University',
  www: 'https://www.calvin.edu',
  logo: 'assets/logos/calvin-university-1876-inverse.png',
  emailDomains: [
    'calvin.edu',
    'students.calvin.edu',
  ],
};
const customerGVSU: CustomerInfo = {
  id: 'Grand Valley State University',
  www: 'https://www.gvsu.edu',
  logo: 'assets/logos/gvsu_logo_blue.svg',
  emailDomains: [
    'gvsu.edu',
  ],
};

export const customer: CustomerInfo = customerCalvin;

// export const customer = 'GVSU';
// export const customer = 'Davenport';

/**
 * Whether this build includes the Knightmeds/Knight Meds integration at all.
 *
 * This is the build-time half of the decision: it controls whether the
 * release/reload routes exist. It does NOT mean every visitor gets the
 * cabinet UI -- see isKnightmedsCabinetMode() for the runtime half.
 */
export const knightMedsInstall = true;

/**
 * Whether *this* browser should run as a medication cabinet rather than as
 * the ordinary EMR.
 *
 * A build with Knightmeds compiled in serves both audiences from one URL: a
 * laptop bolted to a cabinet, and a desktop whose user just wants patient
 * records. What separates them is whether a cabinet id is present -- from
 * `?cabinet=`, from a previous visit, or from the Docker environment
 * variable. With one, login lands on the release pages and the nav bar shows
 * the cabinet actions; without one, login lands on the patients list and the
 * nav bar is the standard EMR.
 *
 * Note this switches the *landing page and navigation*, not which routes
 * exist. The release/reload routes stay registered either way, so a cabinet
 * laptop that has somehow lost its id still gets knightmedsInstanceGuard's
 * "this laptop hasn't been assigned to a cabinet yet" page instead of a
 * bare page-not-found.
 */
export function isKnightmedsCabinetMode(): boolean {
  return knightMedsInstall && hasKnightmedsCabinetId();
}
